import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

const Footer = React.forwardRef((props, ref) => {
  const {
    scrollToAbout,
    scrollToMission,
    scrollToProductsandService,
    scrollToVision,
    scrollToSDB,
  } = props;

  return (
    <footer ref={ref} className="bg-[#38761d] text-white py-12">
      <div className="w-[90%] mx-auto flex flex-col lg:flex-row gap-4">
        <div className="flex flex-col md:flex-row md:items-center lg:items-start mb-8 md:mb-0">
          <img
            src="/logowithrmbg.png"
            alt="Logo"
            className="h-[90px] w-[90px] mr-4 md:mb-0 mb-4"
          />
          <div>
            <h2 className="text-xl font-bold mb-2">Guerate Energy</h2>
            <p className="text-gray-400">
              Empowering Communities for a Cleaner Future.
            </p>
          </div>
        </div>
        <div className="grid md:grid-cols-2  lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">About Us</h3>
            <ul>
              <li
                className="cursor-pointer hover:underline transition-all"
                onClick={scrollToAbout}
              >
                Our Vision
              </li>
              <li
                className="cursor-pointer hover:underline transition-all"
                onClick={scrollToAbout}
              >
                Our Mission
              </li>
              <li
                className="cursor-pointer hover:underline transition-all"
                onClick={scrollToAbout}
              >
                Standing Out
              </li>
              <li
                className="cursor-pointer hover:underline transition-all"
                onClick={scrollToVision}
              >
                Key Objectives
              </li>
              <li
                className="cursor-pointer hover:underline transition-all"
                onClick={scrollToSDB}
              >
                SDG Alignment
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">
              Products &amp; Services
            </h3>
            <ul>
              <li
                className="cursor-pointer hover:underline transition-all"
                onClick={scrollToProductsandService}
              >
                LPG Retailing Service
              </li>
              <li
                className="cursor-pointer hover:underline transition-all"
                onClick={scrollToProductsandService}
              >
                Waste-to-Fuel Mechanism
              </li>
              <li
                className="cursor-pointer hover:underline transition-all"
                onClick={scrollToProductsandService}
              >
                Guerate Accessory Exchange (GAE)
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Blogs/News</h3>
            <ul className="flex flex-col gap-1">
              <Link
                to={"/blogs-and-news"}
                className="cursor-pointer hover:underline transition-all"
              >
                Latest News
              </Link>
              <Link
                className="cursor-pointer hover:underline transition-all"
                to={"/blogs-and-news"}
              >
                Blog Posts
              </Link>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul>
              <li>
                <a href="tel:+234123456789" className="hover:underline">
                  +234 916 6828 999
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@guerateenergy.com"
                  className="hover:underline"
                >
                  info@guerateenergy.com
                </a>
              </li>
              <li>No 25, Dominion Avenue, Mowe, Ogun State.</li>
            </ul>
            <div className="flex gap-4 mt-4">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF className="h-6 w-6" />
              </a>
              <a
                href="https://www.twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <BsTwitterX className="h-6 w-6" />
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="h-6 w-6" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-8 text-center text-gray-400">
        &copy; {new Date().getFullYear()} Guerate Energy. All rights reserved.
      </div>
    </footer>
  );
});

export default Footer;
